import React, { useEffect, useState } from 'react';
import dotenv from 'dotenv';

function CompanyList() {

  const [companies, setCompanies] = useState([]);

  useEffect(() => {

    const fetchCompanies = async () => {

      try {

        const response = await fetch(import.meta.env.VITE_REACT_APP_BACK_NODE_COMPANY_ENDPOINT);
        console.log(import.meta.env.VITE_REACT_APP_BACK_NODE_COMPANY_ENDPOINT)
        if (response.ok) {
          const data = await response.json();
          setCompanies(data);
        } else {
          console.log('Error:', response.status);
        }
      } catch (error) {
        console.log('Error:', error);
      }
    };

    fetchCompanies();
  }, []);

  return (
    <div>
      <h1>Company List</h1>
      <ul>
        {companies.map((company) => (
          <li key={company.id}>
            ID : {company.id} <br />
            SIREN Number: {company.sirenNumber} <br />
            SIRET Number: {company.siretNumber} <br />
            Name: {company.name} <br />
            Adress:{company.address} <br />
            Postcode: {company.postcode} <br />
            Latitude: {company.lat} <br />
            Longitude: {company.lon} <br />
            Revenue: {company.revenue} <br />
            Net Profit: {company.netProfit} <br />

          </li>
        ))}
      </ul>
    </div>
  );
}

export default CompanyList;
